import React from 'react';
import SnackbarContent from '@mui/material/SnackbarContent';

const MessageSnackbar = ({ message, className }) => (
  <SnackbarContent message={message} className={className} />
);

export default MessageSnackbar;
